import { useEffect, useRef } from "react";
import "../styles/ContactUs.css";
import emailjs from "emailjs-com";

export default function ContactUs({ setActive, pagesOut }) {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_s0on2n9",
        "template_toqfkd9",
        form.current,
        "Np7SuxwLheSlAmgTZ"
      )
      .then(
        () => {
          alert("✅ تم إرسال الرسالة بنجاح!");
          form.current.reset();
        },
        () => {
          alert("❌ حدث خطأ، حاول مرة أخرى.");
        }
      );
  };

  useEffect(() => {
    setActive("تواصل معنا");
  }, [setActive]);

  return (
    <div className="contact-container">
      <header className="contact-header">
        <h1 className={`${pagesOut.constactOut ? "fade-out" : "fade-in"}`}>
          تواصل معنا
        </h1>
        <p className={`${pagesOut.constactOut ? "fade-out" : "fade-in"}`}>
          نحن هنا لمساعدتك! لا تتردد في التواصل معنا لأي استفسار أو ملاحظة.
        </p>
      </header>

      <div className="contact-content">
        {/* ------------------------ Contact Info Section ------------------------ */}
        <div className="contact-info">
          <h2 className={`${pagesOut.constactOut ? "fade-out" : "fade-in"}`}>
            معلومات الاتصال
          </h2>

          <div className="contact-options">

            <div className="contact-card" onClick={() => window.open("tel:+201030452252")}>
              <span className="icon">📞</span>
              <p>الهاتف</p>
            </div>

            <div
              className="contact-card"
              onClick={() => window.open("https://wa.me/201556868406", "_blank")}
            >
              <img
                src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/whatsapp.svg"
                className="contact-icon whats"
                alt=""
              />
              <p>واتساب</p>
            </div>

            <div
              className="contact-card"
              onClick={() => window.open("https://t.me/", "_blank")}
            >
              <img
                src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/telegram.svg"
                className="contact-icon tele"
                alt=""
              />
              <p>تليجرام</p>
            </div>

            <div className="contact-card email-card">
              ✉️
              <p>البريد الإلكتروني</p>
            </div>
          </div>
        </div>

        {/* ------------------------ Email Form Section ------------------------ */}
        <form ref={form} className="mail-form" onSubmit={sendEmail}>
          <h1 className="or-text">أو</h1>
          <h2>أرسل رسالة</h2>

          <input
            type="text"
            placeholder="الاسم الكامل"
            name="user_name"
            required
          />
          <input
            type="email"
            placeholder="البريد الإلكتروني"
            name="user_email"
            required
          />
          <textarea placeholder="رسالتك" rows="5" name="message" required></textarea>

          <button type="submit" className="submit-mail">
            إرسال
          </button>
        </form>
      </div>
    </div>
  );
}
